import { generateUuid } from '../../helpers/strings';
import { Provider } from './Provider';
export class FallbackProvider extends Provider {
    currentVisitId;
    currentVisitorId;
    currentViewId;
    get source() {
        if (window.page && window.page.type && window.page.type === 'Homepage') {
            return 'direct';
        }
        return 'undefined';
    }
    get medium() {
        if (window.page && window.page.type && window.page.type === 'Homepage') {
            return 'direct';
        }
        return 'undefined';
    }
    get campaign() {
        if (window.page && window.page.type && window.page.type === 'Homepage') {
            return 'direct';
        }
        return 'undefined';
    }
    get visitId() {
        if (!this.currentVisitId) {
            this.currentVisitId = generateUuid().replace(/-/g, '');
        }
        return this.currentVisitId;
    }
    get visitorId() {
        if (!this.currentVisitorId) {
            this.currentVisitorId = generateUuid().replace(/-/g, '');
        }
        return this.currentVisitorId;
    }
    get viewId() {
        if (!this.currentViewId) {
            this.currentViewId = generateUuid().replace(/-/g, '');
        }
        return this.currentViewId;
    }
}
